/**
 *   Docutain SDK Capacitor
 *   Copyright (c) INFOSOFT Informations- und Dokumentationssysteme GmbH. All rights reserved.
 *
 *   Docutain SDK Capacitor is a commercial product and requires a license.
 *   Details found in the LICENSE file in the root directory of this source tree.
 */
import { WebPlugin } from '@capacitor/core';
export class DocutainSDKWeb extends WebPlugin {
    async initSDK(_options) {
        throw this.unimplemented('initSDK not implemented on web.');
    }
    async scanDocument(_args) {
        throw this.unimplemented('scanDocument not implemented on web.');
    }
    async startDocumentScanner(_options) {
        throw this.unimplemented('scanDocument not implemented on web.');
    }
    async loadFile(_options) {
        throw this.unimplemented('loadFile not implemented on web.');
    }
    async getText() {
        throw this.unimplemented('getText not implemented on web.');
    }
    async getTextPage(_options) {
        throw this.unimplemented('getTextPage not implemented on web.');
    }
    async setAnalyzeConfiguration(_args) {
        throw this.unimplemented('setAnalyzeConfiguration not implemented on web.');
    }
    async setAnalyzeConfigurationDocScan(_options) {
        throw this.unimplemented('setAnalyzeConfigurationDocScan not implemented on web.');
    }
    async analyze() {
        throw this.unimplemented('analyze not implemented on web.');
    }
    async writePDF(_options) {
        throw this.unimplemented('writePDF not implemented on web.');
    }
    async setLogLevel(_options) {
        throw this.unimplemented('setLogLevel not implemented on web.');
    }
    async getTraceFile() {
        throw this.unimplemented('getTraceFile not implemented on web.');
    }
    async deleteTempFiles(_options) {
        throw this.unimplemented('deleteTempFiles not implemented on web.');
    }
    async writeImage(_options) {
        throw this.unimplemented('writeImage not implemented on web.');
    }
    async getImageBytes(_options) {
        throw this.unimplemented('writeImage not implemented on web.');
    }
    async pageCount() {
        throw this.unimplemented('writeImage not implemented on web.');
    }
    async resetOnboarding(_options) {
        throw this.unimplemented('resetOnboarding not implemented on web.');
    }
    async onboardingDefaultItems() {
        throw this.unimplemented('onboardingDefaultItems not implemented on web.');
    }
    async scanTipsDefaultItems() {
        throw this.unimplemented('scanTipsDefaultItems not implemented on web.');
    }
    async startPhotoPayment(_options) {
        throw this.unimplemented('startPhotoPayment not implemented on web.');
    }
    async emptyResultScreenDefaultItems() {
        throw this.unimplemented('emptyResultScreenDefaultItems not implemented on web.');
    }
}
//# sourceMappingURL=web.js.map